import { autoScrollForElements } from '@atlaskit/pragmatic-drag-and-drop-auto-scroll/element';
import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { useEffect } from 'react';

interface UseDropTargetWithAutoScrollProps {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  videoDuration: number;
  stripWidth: number;
  isScrollable: boolean;
  instanceId: symbol;
}

export function useDropTargetWithAutoScroll({
  scrollContainerRef,
  videoDuration,
  stripWidth,
  isScrollable,
  instanceId,
}: UseDropTargetWithAutoScrollProps) {
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    // Combine drop target + auto-scroll following Pragmatic best practices
    const dropTargetCleanup = dropTargetForElements({
      element: container,
      canDrop: ({ source }) => {
        return source.data.type === 'selection-indicator';
      },
      getData: () => ({
        type: 'film-strip-drop-target',
        videoDuration,
        stripWidth,
      }),
    });

    const cleanup = isScrollable
      ? combine(
          dropTargetCleanup,
          autoScrollForElements({
            element: container,
            getAllowedAxis: () => 'horizontal',
            canScroll: ({ source }) =>
              source.data.type === 'selection-indicator' &&
              source.data.instanceId === instanceId,
          })
        )
      : dropTargetCleanup;

    return cleanup;
  }, [scrollContainerRef, videoDuration, stripWidth, isScrollable, instanceId]);
}
